import { EpimsBaseEntityDto } from './epim-base.dto';
export class LandPrefixDto extends EpimsBaseEntityDto {
  LandPrefixCode: string;
  LandPrefixName: string;
  StatCode: string;
  DefaultCode: string;
  AutoMode: string;
  SubscriptionUserId: string;  
  Version: number;
}
